import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Box } from 'grommet'
import styled from 'styled-components'
import { getPersistor } from '../../utils/reduxPersistor'
import { setWebsiteMode } from '../../redux/common/actions'
import { instantInit } from '../../redux/shareWheel/actions'
import { useIsPremium } from '../../hook/useIsPremium'
const ShareModeButtonBox = styled(Box)`
  position: absolute;
  z-index: 10;
  right: 1.5rem;
  top: 2rem;
`

const ShareModeButton = ({
  atCorner = true,
  page,
  quizMode = false,
  ...props
}) => {
  const { websiteMode } = useSelector(state => state.common)
  const { isPremium, isSharePremium } = useIsPremium()
  const dispatch = useDispatch()

  const duplicateWheel = async () => {
    getPersistor().persist()
    await dispatch(instantInit(page, true, isPremium))
    if (!isSharePremium) {
      dispatch(setWebsiteMode('Normal'))
      window.history.pushState({}, '', window.location.pathname)
    } else {
      setTimeout(() => {
        window.location.href = window.location.pathname
      }, 50) //must have timer to let the state log in
      // window.location.href = window.location.pathname
      // window.open(window.location.pathname, '_self')
      // window.history.pushState({}, '', window.location.pathname)
      // window.location.reload()
    }
  }

  const backToWheel = async () => {
    getPersistor().persist()
    await dispatch(instantInit(page, false))
    if (!isSharePremium) {
      dispatch(setWebsiteMode('Normal'))
      window.history.pushState({}, '', window.location.pathname)
    } else {
      setTimeout(() => {
        window.location.href = window.location.pathname
      }, 50) //must have timer to let the state log in
      // window.open('/', '_self')
      // window.history.pushState({}, '', window.location.pathname)
      // window.location.reload()
    }
  }

  // let label = 'Copy & Edit As Own Wheel'
  // if (websiteMode === 'ShareCanEdit') {
  //   label = 'Copy & Edit As Own Wheel'
  // } else if (websiteMode === 'ShareViewOnly') {
  //   label = 'Back to Your Wheel'
  // }
  const ButtonBox = atCorner ? ShareModeButtonBox : Box
  return (
    <ButtonBox gap=".8rem" margin="auto 0 auto 0">
      {websiteMode === 'ShareCanEdit' && (
        <Button
          {...props}
          label="Copy to Your Wheel"
          onClick={duplicateWheel}
          primary
          color="black"
          size="small"
          style={{
            color: 'var(--whiteText)',
            padding: '.4rem 2rem',
            fontSize: '1.4rem',
          }}
        ></Button>
      )}
      <Button
        {...props}
        label={quizMode ? 'Exit Quiz' : 'Exit Wheel'}
        onClick={backToWheel}
        primary
        color="black"
        size="small"
        style={{
          color: 'var(--whiteText)',
          padding: '.4rem 2rem',
          fontSize: '1.4rem',
        }}
      ></Button>
    </ButtonBox>
  )
}

export default ShareModeButton
